import React from 'react';
import { connectWithStore } from '@react/Common/connectWithStore';
import { navigateTo, getUserPermissionsState } from '@redux/ducks/userPermissions/userPermissions';
import { UserPermissionsScreen } from '@redux/ducks/userPermissions/utils';

const AppAccessLinkComponent = ({ isVisible, configuredCount, onClick }) =>
  isVisible ? (
    <div className="panel-section">
      <ul className="app-access-link-list ul-list-with-arrow flex-auto">
        <li>
          <a data-testid="app-access-link" onClick={onClick}>
            {t('label.app-access')}
            {configuredCount > 0 ? (
              <span className="configured-count">
                {configuredCount} {t('users.configured.label')}
              </span>
            ) : null}
          </a>
        </li>
      </ul>
    </div>
  ) : null;

const mapStateToProps = state => {
  const { user } = getUserPermissionsState(state);
  const configuredApps = user.local_roles.mobile_apps.filter(app => app.role);

  return { configuredCount: configuredApps.length, isVisible: user?.role === 'custom' };
};

const navigateToAppList = () => navigateTo(UserPermissionsScreen.APP_LIST);

const mapStateToDispatch = {
  onClick: navigateToAppList,
};

export const AppAccessLink = connectWithStore(mapStateToProps, mapStateToDispatch)(AppAccessLinkComponent);
